module.exports = __webpack_public_path__ + "static/media/malqueridaCup.b0297611.jpg";